import { Injectable } from '@angular/core';
import { PageTabsLayoutPageService } from '@eforall/dashboard';

/**
 * The list of tabs on this page
 */
export enum VolunteeringOverviewPageTabId {
	Overview = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list of main tab droplist views on this page
 */
export enum VolunteeringOverviewPageViewId {
	Overview = 1,
}


@Injectable({ providedIn: 'root' })
export class VolunteeringOverviewService extends PageTabsLayoutPageService<VolunteeringOverviewPageTabId, VolunteeringOverviewPageViewId> {
	constructor() {
		super([], VolunteeringOverviewService.name, VolunteeringOverviewPageTabId.Overview, VolunteeringOverviewPageViewId.Overview);
	}

}